import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ISpinnerState {
    show: boolean;
}

@Injectable()
export class SpinnerService {
    public spinnerSubject: Subject<ISpinnerState> = new Subject<ISpinnerState>();
    public spinnerMessageSubject: Subject<string> = new Subject<string>();
    private showCount: number = 0;

    public setMessage(message: string): void {
        this.spinnerMessageSubject.next(message);
    }

    public show(delay: number = 600, message?: string): void {
        this.showCount++;

        if (message) {
            this.setMessage(message);
        }

        setTimeout(
            () => {
                if (this.showCount > 0) {
                    this.spinnerSubject.next({ show: true });
                }
            },
            delay,
        );
    }

    public hide(clearMessage?: boolean): void {
        this.showCount--;

        if (this.showCount <= 0) {
            this.spinnerSubject.next({ show: false });
        }

        if (clearMessage) {
            this.setMessage(null);
        }
    }
}
